module.exports = __webpack_public_path__ + "static/media/male-front-calves-calves-b.86f83abb.png";